

import React, { useState, useEffect } from "react";
import { Link, } from "react-router-dom";
import axios from "axios";
import { Button, Grid, Grid2, Modal, Stack, Typography } from "@mui/material";
import logo from './../../assets/images/logo@2x.png'
const AuthCodeVerification = () => {
    const [signInCodeEmailerror, setSignInCodeEmailerror] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [OTPEXPIRED, setOTPEXPIRED] = useState(false)
    const [deactivesuccess2, setdeactivesuccess2] = useState(false)
    const [userid, setuserid] = useState()
    const [resendsuccess, setresendsuccess] = useState(false)
    const codeEmailVerficationAction = (email, user_id, otp, tag) => {
        setOTPEXPIRED(false)
        setIsSubmitting(false)
        let req = {
            otp: otp,
            phone: email,
            tag: tag,
            user_id: user_id
        }

        axios.post(`/apiV1/authenticate-email/`, req).then(
            (rep) => {
                if (rep.data) {
                    //setdeactivesuccess2(true)
                    //navigate(`/carddetails-creditcard?id=${rep.data.user_id}`)
                    setuserid(rep.data.user_id)
                    setIsSubmitting(true)
                }
            }
        ).catch((e) => {
            if (e.response.data.errors !== undefined) {
                setIsSubmitting(false)
            }
            if (e.response.data.detail) {
                setOTPEXPIRED(true)
                if (e.response.data.OTPEXPIRED) {
                    setOTPEXPIRED(true)
                }

                setSignInCodeEmailerror(e.response.data.detail)
            }

            if (e.response.data.message) {
                setSignInCodeEmailerror(e.response.data.message)
            }
        })
    }
    const resendOTPFunction = () => {
        let req = {
            phone: useremail,
            tag: tagname
        }
        axios.post(`/apiV1/resend-otp-email/`, req).then(
            (rep) => {
                if (rep.data) {
                    setresendsuccess(true)
                }
            }
        ).catch((e) => {
            if (e.response.data.errors !== undefined) {
                setIsSubmitting(false)

            }
            if (e.response.data.detail) {
                if (e.response.data.OTPEXPIRED) {
                    setOTPEXPIRED(true)
                }

                setSignInCodeEmailerror(e.response.data.detail)
            }
        })
    }
    const [useremail, setuseremail] = useState()
    const [tagname, settagname] = useState()
    useEffect(() => {
        let url = new URL(window.location.href);
        let params = new URLSearchParams(url.search.slice(1));
        let obj = {};
        for (let pair of params.entries()) {
            obj[pair[0]] = pair[1];
        }

        const email = obj["email"] ? obj["email"] : 0;
        const user_id = obj["userid"] ? obj["userid"] : 0;
        const otp = obj["otp"] ? obj["otp"] : 0;
        const tag = obj["tag"] ? obj["tag"] : 0;

        settagname(tag)
        setuseremail(email)
        codeEmailVerficationAction(email, user_id, otp, tag)
    }, [])


    return (

        <div className="container" style={{ marginTop: "10%" }}>
            <div className="row justify-content-md-center">
                <div className="col-md-12 col-lg-4">
                    <div className="card login-box-container">
                        <div className="card-body">
                            <div className="authent-logo">
                                <img src={logo} alt="" />
                            </div>
                            <div className="authent-text">
                                <p>Welcome to Avatar Chatbots</p>
                                <p>Avatar Chatbots account create</p>
                            </div>
                            <div className="authent-reg">
                                {isSubmitting ?
                                    <Stack className="text-center pt-3">
                                        <Typography className="font_18 font_weight_400 DarkBlue2_Color text-success">Your email successfully verified</Typography>
                                    </Stack> :
                                    <Stack className="text-center pt-3">
                                        <Typography className="font_18 font_weight_400 DarkBlue2_Color text-danger">{signInCodeEmailerror}</Typography>
                                    </Stack>}
                                {OTPEXPIRED ?
                                    <Stack className="mt-5">
                                        {resendsuccess ? <Typography className="font_18 font_weight_400 DarkBlue2_Color text-success">Verification Link send successfully</Typography> : ""}
                                        <button type="submit" className="btn btn-info m-b-xs bluebuttoncustom" onClick={() => resendOTPFunction()} >Resend Link</button>

                                    </Stack> :
                                    ""
                                }

                                <Link to="/Login">Sign In</Link>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>


    )
}
export default AuthCodeVerification